<template>
	<div>
		<div class="row text-center gold">
			<h3 class="col">BioTesting Quiz<br /><small v-text="quizTitle"></small></h3>
		</div>

		<b-alert v-if="process_status == 2" show variant="primary">
			<h5><small>Submitted on </small><span v-text="submitted_date"></span></h5>
			<p>We will notify you when your results have been checked.</p>
		</b-alert>

		<div v-else>
			<div class="row text-right small text-secondary mb-2">
				<div class="col" v-html="quizHelp"></div>
			</div>

			<div v-if="sections.length > 0" class="">
				<div v-for="(section, Skey) in sections" :key="Skey" class="row">
					<div class="col-12">
						<div class="card mb-4">
							<h5 class="card-header pointer" v-b-toggle="'section-' + Skey">
								<div class="row">
									<div class="col-8">
										<span v-if="section.data.collapse">
											<i class="fas fa-chevron-up mr-2"></i>
										</span>
										<span v-else>
											<i class="fas fa-plus-square mr-2"></i>
										</span>
										<span v-text="section.data.question"></span>
									</div>
									<div class="col-4 text-right small">
										<span v-if="section.data.complete == 1">
											<i class="fas fa-check text-success mr-2"></i>
										</span>
										<span v-text="section.data.answered"></span> of
										<span v-text="section.data.total"></span> answered
									</div>
								</div>
							</h5>

							<b-collapse
								:id="'section-' + Skey"
								:visible="Skey == 0"
								class=""
								v-model="section.data.collapse"
							>
								<b-list-group v-for="(Q, key) in section.questions" :key="key">
									<b-list-group-item
										v-if="key == 0"
										class="d-flex justify-content-between align-items-center small"
									>
										<span>Symptom</span>
										<span>Severity/Frequency</span>
									</b-list-group-item>
									<b-list-group-item v-if="Q.answer !== null" class="hover">
										<div class="row">
											<p class="col-md-7">
												<span v-if="Q.selected == 1">
													<i class="fas fa-check text-success mr-2"></i>
												</span>
												<span v-else>
													<i
														v-if="Q.selected == 0"
														class="fas fa-exclamation text-warning pr-2"
													></i>
												</span>
												<b v-text="Q.title"></b>
												<i v-if="Q.helpText != ''"
													><br />
													<small class="" v-text="Q.helpText"></small>
												</i>
											</p>

											<div class="col-md-5 text-right">
												<b-form-group
													v-if="Q.options.length > 0"
													v-slot="{ ariaDescribedby }"
												>
													<b-form-radio-group
														v-model="Q.answer_selected"
														:options="Q.options"
														:aria-describedby="ariaDescribedby"
														button-variant="outline-primary"
														size="sm"
														@change="setSelected(Q, 'severity')"
														buttons
													></b-form-radio-group>
												</b-form-group>
											</div>

											<div
												class="offset-md-7 col-md-5"
												:class="{ 'bg-incomplete': Q.selected == 0 }"
											>
												<div
													v-if="Q.answer_selected > 0 && Q.type != 'yesNo'"
													class="row"
												>
													<div class="col-2 text-right">
														<i
															v-if="Q.selected == 0"
															class="fas fa-exclamation text-warning"
														></i>
													</div>
													<div class="col-10 text-right">
														<b-form-select
															size="sm"
															v-model="Q.frequency_selected"
															:options="Q.frequency_options"
															@change="setSelected(Q, 'frequency')"
														></b-form-select>
													</div>
												</div>
											</div>
										</div>
									</b-list-group-item>
								</b-list-group>
							</b-collapse>
							<!--<div class="card-footer">Save progress</div>-->
						</div>
					</div>
				</div>

				<div class="row">
					<div v-if="submit_message != ''" class="col-12 text-center">
						<b-alert show variant="primary" class="m-4">
							{{ submit_message }}
						</b-alert>
					</div>

					<div v-if="sections_complete != sections_total" class="col-12">
						<b-alert show variant="light" class="m-4 text-danger border-danger">
							<h5>
								You have only completed {{ sections_complete }} of
								{{ sections_total }} sections, you need to complete all the questions above
								to submit...<br />
								<small>
									* hint the questions without a
									<i class="fas fa-check text-success"></i> need your attention
								</small>
							</h5>
							<p>
								<b-button size="sm" variant="outline-primary" @click="submitQuiz(9)">
									Save progress
								</b-button>
							</p>
						</b-alert>
					</div>

					<div v-if="canSubmit == 1" class="col-12 text-center">
						<div v-if="processing_submit == 1" class="row">
							<div class="col-12 text-center mt-5 gold">
								<i class="fas fa-spinner fa-spin fa-3x"></i>
								<p>Processing...</p>
							</div>
						</div>
						<b-button v-else variant="success" size="lg" @click="submitQuiz(2)">
							<i class="fas fa-check"></i> Submit
						</b-button>
					</div>
				</div>
			</div>

			<div v-else class="text-center mt-5 gold">
				<div v-if="message != ''">
					<b-alert show variant="primary">{{ message }}</b-alert>
				</div>
				<div v-else>
					<i class="fas fa-spinner fa-spin fa-2x"></i>
					<p>Loading Quiz...</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'BioServerQuiz',
	components: {},
	data() {
		return {
			canSubmit: 0,
			message: '',
			processing_submit: 0,
			process_status: 0,
			submit_message: '',
			submitted_date: '',
			quizTitle: '',
			quizHelp: '',
			sections: [],
			sections_total: 0,
			sections_complete: 0,
		};
	},
	mounted() {
		this.sectionsLoad(this.quizID);
	},

	computed: {
		quizID() {
			return this.$route.params.quiz_id;
		},
	},

	methods: {
		createSubmitData() {
			var data = { questions: [] };

			this.sections.filter((obj) => {
				obj.questions.filter((objA) => {
					var answer = {
						id: objA.id,
						answer: objA.answer_selected,
						frequency: objA.frequency_selected,
					};
					data.questions.push(answer);
				});
			});

			return JSON.stringify(data);
		},

		sectionAnsweredCount(save_progress) {
			this.submit_message = '';

			this.sections.filter((obj, section_id) => {
				var section_answered = 0;
				obj.questions.filter((objQ) => {
					section_answered += objQ.selected;
				});
				obj.data.answered = section_answered;

				if (obj.data.answered > 0 && obj.data.answered == obj.data.total) {
					this.sections[section_id].data.complete = 1;
					section_id++;

					if (this.sections[section_id] && this.sections[section_id].data.collapse == false) {
						this.sections[section_id].data.collapse = true;
						this.$root.$emit('bv::toggle::collapse', 'section-' + section_id);
					}
				} else {
					this.sections[section_id].data.complete = 0;
					section_id++;
				}
			});

			this.sections_complete = 0;

			this.sections.filter((obj) => {
				this.sections_complete += obj.data.complete;
			});

			if (save_progress == 9) {
				this.canSubmit = 1;
			} else if (this.sections_complete > 0 && this.sections_complete == this.sections_total) {
				this.canSubmit = 1;
			} else {
				this.canSubmit = 0;
			}

			return this.canSubmit;
		},
		sectionsLoad(quizID) {
			let _this = this;

			_this.questions = [];
			_this.questions_load = [];
			_this.message = '';

			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('questionnaire_id', quizID);

			axios({
				url: _this.$store.state.api_url + 'bio_questions_load',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						const Q = Object.values(response.data.sections);
						for (const key of Q) {
							_this.sections.push(key);
						}
						_this.sections[0].data.collapse = true;
						_this.sections_total = _this.sections.length;
						_this.quizTitle = response.data.title;
						_this.quizHelp = response.data.help_text;

						_this.sectionAnsweredCount(0);
					} else if (response.data.status == 2) {
						_this.message = response.data.message;
					}
				})
				.catch(function () {});
		},

		setSelected(Q, type) {
			if (Q.type == 'yesNo') {
				Q.selected = 1;
			} else if (type == 'frequency') {
				if (Q.frequency_selected > 0) {
					Q.selected = 1;
				} else {
					Q.selected = 0;
				}
			} else if (type == 'severity') {
				if (Q.answer_selected == 0) {
					Q.selected = 1;
				} else {
					if (Q.frequency_selected == 0) {
						Q.selected = 0;
					}
				}
			}
			this.sectionAnsweredCount(0);
		},

		submitQuiz(progress) {
			let _this = this;
			var canSubmit = this.sectionAnsweredCount(progress);

			if (canSubmit == 1) {
				_this.processing_submit = 1;
				_this.submit_message = '';

				let params = new URLSearchParams();
				params.append('token', this.$store.state.session_id);
				params.append('questionnaire_id', this.quizID);
				params.append('answers', this.createSubmitData());
				params.append('save_progress', progress);

				axios({
					url: _this.$store.state.api_url + 'bio_questions_user_quiz_save',
					params: params,
				})
					.then(function (response) {
						_this.submit_message = response.data.message;
						_this.canSubmit = 0;
						_this.processing_submit = 0;
						_this.submitted_date = response.data.submitted_date;
						_this.process_status = response.data.status;
					})
					.catch(function () {});
			}
		},
	},

	watch: {},
};
</script>

<style>
.text-incomplete {
	color: #fc6028;
}
.bg-incomplete {
	padding: 0px;
	background-color: #fff;
}
.hover:hover {
	background-color: #f9f9f9;
}
</style>
